import styled from "styled-components";

export const PackerWrapper = styled.div`
  /* max-width: 440px; */
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 104px - 60px);
  display: flex;
  flex-flow: column;
  gap: 1em;
  justify-content: space-around;
  /* text-align: center; */
  margin: auto;
  .disabled {
    background: #efefef;
    color: #a6a6a6;
    cursor: not-allowed;
  }
  .btnDisabled {
    background: #e4e4e494;
    color: #a6a6a6;
    border-color: #e4e4e494;
  }
`;
